import React, { useMemo } from 'react'
import type { FacilitatorLiveSessionParticipant } from '../../../../../../pure-js/types/FacilitatorLiveSessionMonitor'
import { ControlTowerParticipantTable } from './ControlTowerParticipantTable'
import { orderMissingFirst } from './controlTowerHelpers'
import { SPRINT_CALL_ROSTER_VISIBLE_ROWS } from './controlTowerStyles'

interface ControlTowerSprintCallRosterProps {
  participants: FacilitatorLiveSessionParticipant[]
  testIdPrefix: string
}

/** Everyone in the sprint, the ones not in the room yet first, scrolling inside the card. */
export const ControlTowerSprintCallRoster: React.FC<ControlTowerSprintCallRosterProps> = ({
  participants,
  testIdPrefix
}) => {
  const orderedParticipants = useMemo(() => orderMissingFirst(participants), [participants])

  return (
    <ControlTowerParticipantTable
      participants={orderedParticipants}
      showPlayedColumn={false}
      testIdPrefix={testIdPrefix}
      visibleRowCount={SPRINT_CALL_ROSTER_VISIBLE_ROWS}
    />
  )
}
